import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, FormControl, Validators } from '@angular/forms';



@Component({
    selector: 'app-reset-email',
    templateUrl: './resetemailpage.component.html',
    styleUrls: ['./resetemailpage.component.scss']
})
export class ResetEmailPageComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
    emailid;
    formdata;
    hidelogin = false;
    hideconfirm = true;
    showErrorMessage: boolean;



    @Input() loginForm: UntypedFormGroup;


    constructor(private route: ActivatedRoute,
                private router: Router,
                private authenticationService: AuthenticationService) { }


    ngOnInit() {
        this.loading = false;
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/home/tabs';

    }



    sendmail(fdata) {

        if (fdata.email === '' ) {

            Object.keys(this.loginForm.controls).forEach(field => {

                const control = this.loginForm.controls[field];
                control.markAsTouched();
                control.updateValueAndValidity();
              });
        }

        this.showErrorMessage = false;

        if (this.loginForm.valid) {
        this.loading = true;
        this.authenticationService.sendemail(fdata.email)
            .subscribe(
                data => {
                
                    const user = data;

                    if (data.results === 'Invalid credentials') {
                        this.showErrorMessage = true;
                        this.loading = false;
                       } else {

                    this.loading = false;
                    this.hidelogin = true;
                    this.hideconfirm = false;
                       }

                },
                error => {
                    this.loading = false;
                     // alert("Error Test");
                });
            }

    }

}
